module.exports = "/fonts/HelveticaNeueMedium.woff?ab1a472f1b42e4324825a29ff13a8df6";